/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PropChallengeConditions } from './prop-challenge-conditions';
import { PropChallengePackageTag } from './prop-challenge-package-tag';

/**
 *
 * @export
 * @interface CreatePropPackageDto
 */
export class CreatePropPackageDto {
    /**
     *
     * @type {string}
     * @memberof CreatePropPackageDto
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropPackageDto
     */
    goalId: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropPackageDto
     */
    challengeId: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropPackageDto
     */
    entityId: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropPackageDto
     */
    entityName: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropPackageDto
     */
    promoCode?: string;
    /**
     *
     * @type {number}
     * @memberof CreatePropPackageDto
     */
    retryDiscountPercent?: number;
    /**
     *
     * @type {PropChallengeConditions}
     * @memberof CreatePropPackageDto
     */
    conditions: PropChallengeConditions;
    /**
     *
     * @type {string}
     * @memberof CreatePropPackageDto
     */
    type: CreatePropPackageDtoTypeEnum;
    /**
     *
     * @type {number}
     * @memberof CreatePropPackageDto
     */
    amount: number;
    /**
     *
     * @type {number}
     * @memberof CreatePropPackageDto
     */
    funding: number;
    /**
     *
     * @type {PropChallengePackageTag}
     * @memberof CreatePropPackageDto
     */
    tag?: PropChallengePackageTag;
}

/**
 * @export
 * @enum {string}
 */
export enum CreatePropPackageDtoTypeEnum {
    Starter = 'starter',
    Standard = 'standard',
    Advanced = 'advanced',
    Expert = 'expert',
    Master = 'master',
    Professional = 'professional',
    Champion = 'champion',
    Elite = 'elite',
    Supreme = 'supreme',
    Ultimate = 'ultimate',
    Legendary = 'legendary',
    Mythical = 'mythical',
    Titan = 'titan',
    Olympian = 'olympian',
    Cosmic = 'cosmic',
    Bronze = 'bronze',
    Silver = 'silver',
    Gold = 'gold',
    Platinum = 'platinum',
    Diamond = 'diamond',
}
